import React, { useContext } from 'react';
import styled from 'styled-components';
import { Button, Modal, Text } from 'components';
import { makeModalResponsive } from 'utils';
import AppointmentDeskContext, {
  AppointmentDeskStep,
} from '../AppointmentDeskContext';

const ActionButton: React.FC = () => {
  const {
    subscriptionType,
    createSubscription,
    disableSubscribeBtn,
    subscribeBtnLoading,
    setCurrentStep,
  } = useContext(AppointmentDeskContext);

  const onBack = () => {
    makeModalResponsive(
      Modal.confirm({
        title: 'Are you sure you want to leave?',
        okText: 'Yes',
        cancelText: 'Cancel',
        centered: true,
        onOk: () => {
          setCurrentStep(AppointmentDeskStep.ManageListings);
        },
        content: (
          <Text type="secondary">
            Your live concierge service has not been activated. Are you sure you
            want to leave this page?
          </Text>
        ),
      }),
    );
  };

  return (
    <>
      <StyledSubscribe
        type="primary"
        size="large"
        loading={subscribeBtnLoading}
        disabled={disableSubscribeBtn}
        onClick={createSubscription}
        data-cy="subscribe-button"
      >
        Subscribe
      </StyledSubscribe>
      <StyledBack
        type="link"
        size="large"
        onClick={onBack}
        data-cy="back-button"
      >
        Back
      </StyledBack>
      <StyledSmallText type="secondary">
        Your first invoice will be charged on the &quot;Start Date&quot;
        selected above
        {subscriptionType === 'org' &&
          ' for the total number of active listings'}
        .
      </StyledSmallText>
    </>
  );
};

const StyledSubscribe = styled(Button)`
  align-self: stretch;
  margin-top: 24px;
  margin-bottom: 16px;
`;

const StyledBack = styled(Button)`
  align-self: stretch;
  margin-bottom: 24px;
`;

const StyledSmallText = styled(Text)`
  && {
    font-size: 12px;
    line-height: 20px;
    align-self: center;
    width: 70%;
    text-align: center;
  }
`;

export default ActionButton;
